import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { appConstantSettings } from 'srcReact/appConstantSettings'
import BackNavigation from 'srcReact/components/common2/BackNavigation'
import MixrCard from 'srcReact/components/common2/MixrCard'
import NotFound from 'srcReact/components/common2/NotFound'
import { groupHomeActions } from 'srcReact/GroupHomePage/actions'
import { formatDate, getDateFormat10 } from 'srcReact/helpers/datetimeHelper'
import styles from './styles.module.scss'
import { rsvpActions } from 'srcReact/components/common2/RSVP/actions'

function MixrsPerDay({ group, dateForMixrs, setDateForMixrs }) {
  const { t } = useTranslation()
  const [mixrs, setMixrs] = useState([])
  const [date, setDate] = useState('')
  const {
    rsvp: { loading: rsvpLoading, success: rsvpSuccess, error: rsvpError, data: rsvpData },
    calWidget: { groupCalendar }
  } = useSelector((state) => state)
  const dispatch = useDispatch()

  useEffect(() => {
    if (dateForMixrs) {
      const dateObj = new Date(dateForMixrs)
      setDate(formatDate(dateObj, getDateFormat10()))
      if (groupCalendar) {
        const inputDate = formatDate(dateForMixrs, appConstantSettings.DATE_FORMAT8)
        const dateFound = groupCalendar.find((x) => x.date === inputDate)
        if (dateFound) {
          setMixrs(dateFound.events)
        }
      }
    }
  }, [dateForMixrs, groupCalendar])

  useEffect(() => {
    if (!rsvpLoading && rsvpSuccess && rsvpData) {
      dispatch(groupHomeActions.updateRSVPData(rsvpData.mixr_id, rsvpData.attending, 0))
      dispatch(rsvpActions.clearData())

      //update mixrs on calendar for particular date. On update dot color will change to green or red
      const updateEvents = mixrs.map((x) => {
        if (x.mixr_id === rsvpData.mixr_id) {
          x.user_attending_type = rsvpData.attending
        }
        return x
      })
      setMixrs(updateEvents)
    }
  }, [rsvpLoading, rsvpSuccess])

  return (
    <div className={styles.mixrsContainer}>
      <BackNavigation className={styles.backWrapper} title={date} customHandleBack={() => setDateForMixrs('')} />
      {mixrs && mixrs.length > 0 ? (
        <div className={styles.mixrs}>
          {mixrs.map((m, i) => {
            return (
              <MixrCard
                key={i}
                mixrId={m.mixr_id}
                groupId={m.group_id}
                isMixrOver={m.is_over}
                picture={m.mixr_picture}
                startDate={m.event_utc_start_datetime}
                endDate={m.event_utc_end_datetime}
                utcOffset={m.event_utc_offset || '+00:00'}
                timezone={m.timezone}
                participants={m.number_of_participants}
                url={m.mixr_url}
                title={m.mixr_title}
                name={m.group_title}
                description={m.mixr_description}
                color={m.mixr_color ? m.mixr_color : appConstantSettings.DEFAULT_COLOR.name}
                isRecurrence={m.recurrence_type !== 'simple'}
                attendance={m.mixr_attending_type}
                userAttendance={m.user_attending_type}
                layout='horizontal'
                organizer={{ name: group.organizer.display_name }}
                menuPortalTarget={true}
                withGroupDetails={true}
                groupAttendingStatus={group && group.logged_user.group_attending}
                isVisibility={group.privacy_setting !== 'public'}
                mixrOrganizer={`${m.organizer_firstname} ${m.organizer_lastname}`}
                withoutGroupApproval={m.without_group_approval}
                isInvited={m.is_invited === 1}
                mixrRole={m.role_mixr}
                groupRole={m.role_group}
              />
            )
          })}
        </div>
      ) : (
        <NotFound title={t('dashboard.activity.newMixrs.empty.title')} />
      )}
    </div>
  )
}

export default MixrsPerDay
